const toggleDarkmode = () => {
	document.body.classList.toggle('darkmode');
}

export { toggleDarkmode };
